import { getAuthTokenPayload } from 'utils/authStorage'

const useRole = () => {
  const tokenData = getAuthTokenPayload()
  const role = tokenData?.data?.role
  //super admin -> full-access
  //admin -> super admin lite
  //user -> admin read only
  //member -> member

  return role?.toLowerCase?.() ?? role
}

export default useRole
